import React, {useState} from "react";
import Button from "../buttons/Button";

import './Input.tag.scss';
import {useTranslation} from "react-i18next";
import AuditTrail, {PAGES} from "../../services/interactions/audit.trail";

export default function InputTag({ tagsList, onAddTag, labelButton }) {
    const {t} = useTranslation(['users'])
    const [tag, _setTag] = useState('');
    const [preTags, setPreTags] = useState([]);

    const [isFocused, setIsFocused] = useState(false);
    const inputRef = React.createRef();
    const focusOnInput = () => {
        inputRef.current.focus();
        setIsFocused(true);
    }
    const blurOnInput = () => {
        setIsFocused(false);
    }

    const inputKeyDown = (e) => {
        if (e.keyCode === 8) {
            if (!tag.length && preTags.length) {
                const _preTags = JSON.parse(JSON.stringify(preTags));
                _preTags.splice(-1, 1);
                setPreTags(_preTags);
            }
        }
    }
    const setTag = (e) => {
        const tagString = e.target.value;
        const tagsBuild = tagString.split(',');
        console.log('tagString: ', tagString);
        console.log('tagsBuild: ', tagsBuild);
        if (tagsBuild.length > 1) {
            const taggToAdd = tagsBuild[0].split('').filter(s => /^[A-Za-z]+$/.test(s)).join('')
            if (taggToAdd.length > 0) {
                preTags.push(taggToAdd);
                setPreTags(preTags);
            }
            _setTag(tagsBuild[1].split('').filter(s => /^[A-Za-z]+$/.test(s)).join(''));
        } else {
            _setTag(tagString.split('').filter(s => /^[A-Za-z]+$/.test(s)).join(''));
        }
    }

    const addTags = () => {
        const _tagsList = tagsList || [];
        AuditTrail.sendLog(PAGES.PARTICIPANTS_CREATE, {tag: 'button', event: 'onClick', action: 'button add tags', value: preTags});
        onAddTag(_tagsList.concat(JSON.parse(JSON.stringify(preTags))));
        setPreTags([]);
    }

    const removeTag = (i) => {
        return () => {
            AuditTrail.sendLog(PAGES.PARTICIPANTS_CREATE, {tag: 'button', event: 'onClick', action: 'button del tags', value: tagsList[i]});
            tagsList.splice(i, 1);
            onAddTag(JSON.parse(JSON.stringify(tagsList)));
        }
    }

    return (
        <div className={`_tagsList ${isFocused ? 'focused' : ''}`}>
            <input ref={inputRef} value={tag} onKeyDown={inputKeyDown} onChange={setTag} onBlur={blurOnInput} />
            <label>{t('care-activities')}</label>
            <div data-plaholder={t('separate-tags')} className={`_pseudoInput ${isFocused ? 'focused' : ''} ${!tag && preTags.length === 0 ? '_preTags' : ''}`} onClick={focusOnInput}>
                {
                    preTags.map((_tag, i) => (
                        <span className="_tag" key={i}>
                            {_tag}
                        </span>
                    ))
                }
                <p>
                    {tag}
                </p>
            </div>
            <Button disabled={!preTags.length} handleClick={addTags}>
                <span>
                    {labelButton}
                </span>
            </Button>
            <div className="_assignedTags">
                {
                    (tagsList || []).map((tag, i) => (
                        <span className="setTag" key={i}>
                            <span>{tag}</span>
                            <span className="material-icons" onClick={removeTag(i)}>close</span>
                        </span>
                    ))
                }
            </div>
        </div>
    )
}
